import { SearchFilter, SearchList } from '../../services/types/Search';
import { Action, ApiState } from '../../types';
import { callService, serviceReducer } from '../../shared/hooks/serviceReducer';

export type ResultAction = Action<SearchList, SearchFilter> | { type: 'PAGE'; value: number };

const reducer = (
  state: ApiState<SearchList, SearchFilter>,
  action: ResultAction
): ApiState<SearchList, SearchFilter> => {
  if (action.type === 'PAGE') {
    return callService(state, { ...state.filter, pageNumber: action.value });
  }
  return serviceReducer(state, action);
};

export default reducer;
